import React from "react";
import "../AboutTaxes.css";

function Section142_1() {
  return (
    <section className="blog-container">
      <div className="blog-header">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="blog-date">12 July, 2023</div>
      </div>
      <hr />
      <div className="blog-title">Frequently Asked Questions</div>
      <hr />
      <div className="blog-content">
        <div className="content-section">
          <div className="content-subheading">
            When can notice under section 142(1) be issued?
          </div>
          <div className="content-paragraph">
            Notice under section 142(1) is issued when the assessee still needs
            to file or where the return is filed for producing required
            documents asked by the A.O.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Who can serve notice under section 142 for making any inquiry before
            the assessment?
          </div>
          <div className="content-paragraph">
            AO, i.e., the assessing officer can serve the notice under section
            142(1)
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What do I do when I receive a 142(1) notice from the income tax
            department?
          </div>
          <div className="content-paragraph">
            When notice is received for filing the return, an assessee should
            file his return within the time period provided in the notice, and
            if documents and details are asked to produce and then provide the
            same to A.O. within the specified period.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What can I expect after submitting my ITR under section 142(1)?
          </div>
          <div className="content-paragraph">
            After filing of ITR under section 142(1), there are chances of
            notice under section 143(2) for scrutiny assessment if any
            information is sought by A.O. from the documents and information
            submitted by you. Otherwise, if the return is filed as per the
            section, no further action will be taken.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How to respond to Income Tax Notice u/s 142(1)?
          </div>
          <div className="content-paragraph">
            Notice under Section 142(1) can be responded to electronically only
            with the help of 'e-Proceedings' in the assessee's registered
            'e-Filing' accounts.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is the time limit for issuing section 142(1) notice?
          </div>
          <div className="content-paragraph">
            There are no maximum limits to issue the notice u/s 142(1). This
            notice can be issued even after the end of the particular assessment
            year.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is the penalty for 142(1) notice?
          </div>
          <div className="content-paragraph">
            <div className="content-ul">
              <li>
                A penalty of Rs 10,000 can be imposed on you u/s 271(1) (b).
              </li>
              <li>
                A warrant may also be issued u/s 132 for conducting a search.
              </li>
            </div>
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Can I get the wrong notice from the income tax department?
          </div>
          <div className="content-paragraph">
            Normally, it is impossible to receive a wrong notice from ITD, but
            it may happen that the PAN mentioned needs to be corrected in the
            notice; in that case, you may get a notice from the income tax
            department.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is inquiry before assessment in income tax?
          </div>
          <div className="content-paragraph">
            A notice under section 142(1) is issued by the Assessing Officer to
            conduct a preliminary investigation into the mismatch between the
            income tax return filed by the assessee and the information
            available to the AO. It is a way of asking for more details from the
            assessee before making the final assessment by the AO.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is assessment proof of income tax?
          </div>
          <div className="content-paragraph">
            An Income Tax Assessment Order is a notice sent by the Assessing
            Officer to the assessee. It shows the calculation of the total
            income that the assessee earned in the previous year. It is based on
            the assessment of the income tax return filed by the assessee.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is the difference between income tax returns and assessments?
          </div>
          <div className="content-paragraph">
            The assessment year is the year (from April 1 to March 31) in which
            you pay tax on the income you earned in the previous financial year.
            You have to file your income tax return for the income you received
            in the financial year in the corresponding assessment year. The
            assessment year comes right after the financial year.
          </div>
        </div>
      </div>
      <hr />
      <div className="blog-footer">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="next-button">
          <button>Next</button>
        </div>
      </div>
    </section>
  );
}

export default Section142_1;
